import React, { useState, useCallback } from 'react'
import { SafeAreaView } from 'react-native'
import { useSetRecoilState } from 'recoil'
import { useFocusEffect } from '@react-navigation/native'
import { ScrollView } from 'react-native-gesture-handler'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { GetTheme, GetUnits, SaveTheme, UploadFile } from '@/domain/usecases'
import { useErrorHandler, useImage, useTheme, useThemeClient } from '@/presentation/hooks'
import { Box, HStack, VStack, PageHeader } from '@/presentation/components'
import { unitsState } from '@/presentation/pages/Settings/components'
import { ActionsButtons, ColorPicker, LoginBackgroundSelector, LogoSelector, ModalOnDiscardChanges, ModalOnSaveChanges, isLoadingState } from '@/presentation/pages/Theme/components'
import { styles } from './styles'

export type ThemeProps = {
  getTheme: GetTheme
  saveTheme: SaveTheme
  uploadFile: UploadFile
  getUnits: GetUnits
}

export const Theme: React.FC<ThemeProps> = ({
  getTheme,
  saveTheme,
  uploadFile,
  getUnits
}) => {
  const theme = useTheme()
  const handleError = useErrorHandler()
  const { getImage } = useImage()
  const { hasChanged, setThemeClient } = useThemeClient()
  const [logoEmpresa, setLogoEmpresa] = useState('')
  const [backgroundEmpresa, setBackgroundEmpresa] = useState('')
  const setLoading = useSetRecoilState(isLoadingState)
  const setUnits = useSetRecoilState(unitsState)

  useFocusEffect(
    useCallback(() => {
      setLoading(true)

      getTheme
        .get()
        .then(async theme => {
          setThemeClient(theme)
          void getImage(theme.imageLogo, 'logo')
            .then(logo => { setLogoEmpresa(logo) })
            .catch(console.error)

          void getImage(theme.bgLogin, 'login')
            .then(background => { setBackgroundEmpresa(background) })
            .catch(console.error)
        })
        .catch(handleError)
        .finally(() => setLoading(false))

      getUnits
        .getAll()
        .then(units => {
          setUnits({ units, currentUnit: units[0].codigoUnidade })
        })
        .catch(handleError)
    }, [])
  )

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.scroll}>
        <Box style={styles.content}>
          <PageHeader
            text='Tema'
            icon={<MaterialCommunityIcons size={24} color={theme.colors.grey} name='brush-variant' />}
          />
          <HStack wrap spacing={24}>
            <ColorPicker label='Cor principal' name='mainColor' />
            <ColorPicker label='Cor dos botões de confirmação' name='buttonSave' />
          </HStack>
          <HStack wrap spacing={24}>
            <ColorPicker label='Cor do título da tela de login' name='loginColor' />
            <ColorPicker label='Cor dos ícones do menu superior' name='menuColor' />
          </HStack>
          <VStack m={16}>
            <LogoSelector fileName={logoEmpresa} />
            <LoginBackgroundSelector fileName={backgroundEmpresa} />
          </VStack>
        </Box>
      </ScrollView>
      {hasChanged() && <ActionsButtons uploadFile={uploadFile} saveTheme={saveTheme} />}
      <ModalOnSaveChanges uploadFile={uploadFile} saveTheme={saveTheme} />
      <ModalOnDiscardChanges />
    </SafeAreaView>
  )
}
